import React, { FC, useContext } from "react";
import { defineMessages, useIntl } from "react-intl";

import { DrawRequestContext, IntlContext, ProfileContext } from "@app/provider";
import { DrawRequestTimeslots } from "@app/provider/drawRequest";
import TimeslotsForm, {
  TimeslotsFormData,
} from "@app/components/forms/timeslotsForm/timeslotsForm";

import "./modifyAppointment.scss";
import StepperHeaderProgress from "@app/components/stepperHeaderProgress/stepperHeaderProgress";
import { StepperContent } from "@app/components/ui/layout";
import { TestType } from "@app/provider/testData/types";
import TimeslotsDescription from "@app/components/sampleDraw/mobilePhlebotomy/timeslotsDescription/timeslotsDescription";

const messages = defineMessages({
  mobilePhlebotomyTimeslotsTitle: {
    id: "mobilePhlebotomyTimeslotsTitle",
    defaultMessage: "Mobile Blood Draw",
  },
  mobilePhlebotomyTimeslotsDescriptionTitle: {
    id: "mobilePhlebotomyTimeslotsDescriptionTitle",
    defaultMessage: "When are some good times for your blood draw?",
  },
  mobilePhlebotomySubmitAppointmentRequest: {
    id: "mobilePhlebotomySubmitAppointmentRequest",
    defaultMessage: "Submit",
  },
});

export interface ModifyAppointmentProps {
  handleBackToTimeConfirmation: () => void;
  testType?: TestType;
  orderUidPublic?: string;
  testUid?: string;
  token?: string;
}

const ModifyAppointment: FC<ModifyAppointmentProps> = ({
  handleBackToTimeConfirmation,
  ...props
}) => {
  const intl = useIntl();
  const { isLoading, updateDrawRequest, openUpdateDrawErrorDialog } =
    useContext(DrawRequestContext);

  const { updatePatientLanguage } = useContext(ProfileContext);
  const { currentLanguage } = useContext(IntlContext);

  const handleModifyTimeslots = async (data: TimeslotsFormData) => {
    try {
      await updatePatientLanguage(currentLanguage, props.token);
      await updateDrawRequest({
        timeZone: data.timeZone,
        timeSlots: data.timeSlots as DrawRequestTimeslots,
        ...props,
      });
      handleBackToTimeConfirmation();
    } catch {
      openUpdateDrawErrorDialog();
      handleBackToTimeConfirmation();
    }
  };

  return (
    <StepperContent
      title={intl.formatMessage(messages.mobilePhlebotomyTimeslotsTitle)}
      subTitle={intl.formatMessage(
        messages.mobilePhlebotomyTimeslotsDescriptionTitle
      )}
      description={<TimeslotsDescription />}
    >
      <>
        <StepperHeaderProgress />
        <TimeslotsForm
          handleConfirm={handleModifyTimeslots}
          handleBack={handleBackToTimeConfirmation}
          confirmButtonLabel={intl.formatMessage(
            messages.mobilePhlebotomySubmitAppointmentRequest
          )}
          isLoading={isLoading}
        />
      </>
    </StepperContent>
  );
};

export default ModifyAppointment;
